export const ACTIONS = 'actions';
export const AUTOMATION = 'automation';
export const BLOG = 'blog';
export const BUSINESS_INTELLIGENCE = 'business-intelligence';
export const CONTACTS = 'contacts';
export const CONTENT = 'content';
export const CONTENT_SETTINGS = 'content-settings';
export const E_COMMERCE = 'e-commerce';
export const EMAIL = 'email';
export const FILES = 'files';
export const FORMS = 'forms';
export const HUBDB = 'hubdb';
export const INTEGRATION_SYNC = 'integration-sync';
export const LANDING_PAGES = 'landing-pages';
export const LISTS = 'lists';
export const OAUTH = 'oauth';
export const PROJECTS = 'projects';
export const REPORTS = 'reports';
export const SOCIAL = 'social';
export const TICKETS = 'tickets';
export const TIMELINE = 'timeline';
export const TRANSACTIONAL_EMAIL = 'transactional-email';